import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-path=\"url(#a)\" clip-rule=\"evenodd\"><path d=\"M4.862 10.862c.26-.26.682-.26.943 0L8 13.057l2.195-2.195a.667.667 0 1 1 .943.943l-2.667 2.667a.667.667 0 0 1-.942 0l-2.667-2.667a.667.667 0 0 1 0-.943\"></path><path d=\"M8 7.333c.368 0 .667.299.667.667v6a.667.667 0 1 1-1.334 0V8c0-.368.299-.667.667-.667\"></path><path d=\"M5.778 1.33a6 6 0 0 1 5.876 4.003h.345a4.001 4.001 0 0 1 2.304 7.272.667.667 0 0 1-.767-1.09 2.667 2.667 0 0 0-1.535-4.848h-.841a.67.67 0 0 1-.646-.501A4.666 4.666 0 1 0 2.5 10.418a.667.667 0 0 1-.998.884A6 6 0 0 1 5.778 1.33\"></path></g><defs><clipPath id=\"a\"><path fill=\"currentColor\" d=\"M0 0h16v16H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })